/** Placeholder shaped like Stripe's card fields, shown until the payment form is ready. */
const CheckoutSkeleton = () => (
  <div className="checkout-skeleton" aria-hidden="true" data-testid="checkout-skeleton">
    <span className="checkout-skeleton__label" />
    <span className="checkout-skeleton__field" />
    <div className="checkout-skeleton__row">
      <div>
        <span className="checkout-skeleton__label" />
        <span className="checkout-skeleton__field" />
      </div>
      <div>
        <span className="checkout-skeleton__label" />
        <span className="checkout-skeleton__field" />
      </div>
    </div>
    <span className="checkout-skeleton__label" />
    <span className="checkout-skeleton__field" />
  </div>
);

export default CheckoutSkeleton;
